import React, { useState } from "react";
import { Table, Popconfirm, Tag, Select, Card, Button, Space, Typography, Modal, Form, Input } from "antd";

const roleOptions = [
  { label: "Viewer", value: "viewer" },
  { label: "Scheduler", value: "scheduler" },
  { label: "Editor", value: "editor" },
  { label: "Admin", value: "admin" }
];

export default function UserRoleManager() {
  const [users, setUsers] = useState([
    { id: 1, name: "John Doe", email: "john@example.com", role: "viewer" },
    { id: 2, name: "Sarah Lee", email: "sarah@example.com", role: "scheduler" },
    { id: 3, name: "Michael Ray", email: "michael@example.com", role: "editor" }
  ]);

  const [modalOpen, setModalOpen] = useState(false);
  const [form] = Form.useForm();

  const handleRoleChange = (id, newRole) => {
    setUsers(prev => prev.map(u => (u.id === id ? { ...u, role: newRole } : u)));
  };

  const columns = [

    {
      title: "Name",
      dataIndex: "name",
      key: "name"
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email"
    },
    {
      title: "Role",
      key: "role",
      render: (_, record) => (
        <Select
          value={record.role}
          onChange={value => handleRoleChange(record.id, value)}
          style={{ width: 140 }}
          options={roleOptions}
        />
      )
    },
        {
      title: "Workspace",
      key: "workspace",
      render: (_, record) => {
        const mode = record.workspaceMode || "all";
        return (
          <div>
            <Select
              value={mode}
              style={{ width: 180, marginBottom: 8 }}
              options={[
                { label: "All Workspaces", value: "all" },
                { label: "Select Workspaces", value: "select" }
              ]}
              onChange={value => {
                setUsers(prev => prev.map(u => u.id === record.id ? { ...u, workspaceMode: value, workspace: value === "all" ? [] : (u.workspace || []) } : u));
              }}
            />

            {mode === "select" && (
              <Select
                mode="multiple"
                value={record.workspace || []}
                style={{ width: 180 }}
                onChange={value => setUsers(prev => prev.map(u => u.id === record.id ? { ...u, workspace: value } : u))}
                options={[
                  { label: "Workspace A", value: "ws_a" },
                  { label: "Workspace B", value: "ws_b" },
                  { label: "Workspace C", value: "ws_c" }
                ]}
              />
            )}
          </div>
        );
      }
    },

    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Popconfirm
          title="Remove this user?"
          okText="Yes"
          cancelText="No"
          onConfirm={() => setUsers(prev => prev.filter(u => u.id !== record.id))}
        >
          <Button danger>Remove</Button>
        </Popconfirm>
      )
    },
  ];

  const openAddUser = () => {
    form.resetFields();
    setModalOpen(true);
  };

  const submitUser = () => {
    form.validateFields().then(values => {
      const newUser = {
        id: Date.now(),
        ...values
      };
      setUsers(prev => [...prev, newUser]);
      setModalOpen(false);
    });
  };

  return (
    <Card>
      <Space style={{ marginBottom: 20, width: "100%", justifyContent: "space-between" }}>
        <Typography.Title level={4}>Manage Users</Typography.Title>
        <Button type="primary" onClick={openAddUser}>Add User</Button>
      </Space>

      <Table columns={columns} dataSource={users} rowKey="id" pagination={false} />

      <Modal
        title="Add New User"
        open={modalOpen}
        onCancel={() => setModalOpen(false)}
        onOk={submitUser}
        okText="Create"
      >
        <Form layout="vertical" form={form}>
          <Form.Item name="name" label="Name" rules={[{ required: true }]}>
            <Input placeholder="Enter name" />
          </Form.Item>

          <Form.Item name="email" label="Email" rules={[{ required: true, type: "email" }]}>
            <Input placeholder="Enter email" />
          </Form.Item>

          <Form.Item name="role" label="Role" initialValue="viewer" rules={[{ required: true }]}>
            <Select options={roleOptions} />
          </Form.Item>

          <Form.Item name="workspaceMode" label="Workspace" initialValue="all" rules={[{ required: true }]}>
            <Select
              options={[
                { label: "All Workspaces", value: "all" },
                { label: "Select Workspaces", value: "select" }
              ]}
              onChange={value => form.setFieldValue("workspace", value === "all" ? [] : form.getFieldValue("workspace"))}
            />
          </Form.Item>

          <Form.Item shouldUpdate={(prev, curr) => prev.workspaceMode !== curr.workspaceMode}>
            {({ getFieldValue }) =>
              getFieldValue("workspaceMode") === "select" && (
                <Form.Item name="workspace" label="Select Workspaces" initialValue={[]} rules={[{ required: true }]}> 
                  <Select
                    mode="multiple"
                    options={[
                      { label: "Workspace A", value: "ws_a" },
                      { label: "Workspace B", value: "ws_b" },
                      { label: "Workspace C", value: "ws_c" }
                    ]}
                  />
                </Form.Item>
              )
            }
          </Form.Item>
        </Form>
      </Modal>
    </Card>
  );
}
